module.exports = __webpack_public_path__ + "static/media/daniel_new.8cc0e36e.jpg";